import onUserHasConsentedToCookies from "../../../onUserHasConsentedToCookies";

export default class GoogleMap {
    static init() {
        onUserHasConsentedToCookies('statistics', () => GoogleMap.initAfterConsent(), true);
    }

    static initAfterConsent() {
        Array.prototype.forEach.call(document.querySelectorAll('.google-map:not(.google-map--is-initialized)'), el => {
            new GoogleMap(el);
        });
    }

    constructor(element) {
        if (!element) return;

        const embedUrl = element.dataset.src;
        if (!embedUrl) return;

        element.querySelector('.google-map--cookie-notice').remove();

        const iframeElement = document.createElement('iframe');
        iframeElement.setAttribute('width', '100%');
        iframeElement.setAttribute('height', '480');
        iframeElement.setAttribute('src', embedUrl);

        element.classList.add('google-map--is-initialized');
        element.appendChild(iframeElement);
    }
}
